import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { type Cart, type PairingBundle } from '@hungryroot/rest';
import { deleteBundleRequest } from '@hungryroot/rest/api/v2/customers/[id]/cart/bundles/[bundle_id]/delete';
import { type Location } from '@hungryroot/segment';
import { CartChangeType, executeRequestChangeHandlers } from '../useCartEvents';

interface Params
  extends UseMutationOptions<
    Cart,
    unknown,
    {
      bundleId: number;
      pairingId: number;
      pairingName: string;
      location?: Location;
    },
    {
      previousCart: Cart | null;
      bundle: PairingBundle | null;
    }
  > {}

export function useDeleteBundleSelf(props: Params) {
  const { onSettled, onMutate, onError } = props;
  return useMutation<
    Cart,
    unknown,
    {
      bundleId: number;
      pairingId: number;
      pairingName: string;
      location?: Location;
    },
    { previousCart: Cart | null; bundle: PairingBundle | null }
  >({
    mutationFn: async (params) => {
      executeRequestChangeHandlers({
        type: CartChangeType.RequestRemoveRecipe,
      });
      const res = await deleteBundleRequest(params.bundleId);
      if (res.status !== 200) {
        throw res.data;
      }
      return res.data;
    },
    onSettled,
    onMutate,
    onError,
  });
}
